import type { Settlement } from '../engine/map/settlement';
import { recordProduced } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

function runFishRegen(settlement: Settlement): boolean {
    const config = getGameConfig();
    const { fishCap } = settlement.regionResources;
    if (fishCap <= 0) return false;
    settlement.production.ecology.fishTick += 1;
    if (settlement.production.ecology.fishTick < config.time.ticksPerHour) return false;
    settlement.production.ecology.fishTick -= config.time.ticksPerHour;
    const deficit = Math.max(0, fishCap - settlement.regionResources.fish);
    if (deficit <= 0) return false;
    const regen = deficit * config.fish.regenRate;
    if (regen <= 0) return false;
    settlement.regionResources.fish = Math.min(fishCap, settlement.regionResources.fish + regen);
    return true;
}

export function runFishingTick(settlement: Settlement): boolean {
    let changed = false;
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'fishingHut', 'fish');
    const storage = getBuildingStorage(settlement, 'fishingHut');

    if (runFishRegen(settlement)) changed = true;

    if (settlement.buildings.fishingHut.qty <= 0 || settlement.jobs.fishers <= 0) {
        const hadWork = settlement.production.fishing.progress.length > 0;
        settlement.production.fishing.progress = [];
        return changed || hadWork;
    }
    while (settlement.production.fishing.progress.length < settlement.jobs.fishers) {
        settlement.production.fishing.progress.push(0);
        changed = true;
    }
    while (settlement.production.fishing.progress.length > settlement.jobs.fishers) {
        settlement.production.fishing.progress.pop();
        changed = true;
    }

    if (settlement.regionResources.fish <= 0) return changed;

    const { ticksPerCatch, fishPerCatch } = config.production.fishing;
    for (let i = 0; i < settlement.production.fishing.progress.length; i += 1) {
        if (settlement.regionResources.fish < fishPerCatch) break;
        if (outputCap <= 0 || outputCap - storage.fish < fishPerCatch) break;
        settlement.production.fishing.progress[i] += 1;
        if (settlement.production.fishing.progress[i] >= ticksPerCatch) {
            settlement.production.fishing.progress[i] -= ticksPerCatch;
            settlement.regionResources.fish = Math.max(
                0,
                settlement.regionResources.fish - fishPerCatch,
            );
            storage.fish += fishPerCatch;
            recordProduced(settlement, 'fish', fishPerCatch);
            changed = true;
        }
    }

    return changed;
}
